import { render, staticRenderFns } from "./_betListFGLG.vue?vue&type=template&id=fe7934ee&lang=pug&"
import script from "./_betListFGLG.vue?vue&type=script&lang=js&"
export * from "./_betListFGLG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports